import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                toggleState: 'toggleState'
            }
        }
    }

    toggleState() {
        this.el.classList.toggle('-activated');
    }
}
